/**
 * @fileoverview
 * Renders letter box missions specific table
 * Handles logic for formatting data
 * Uses SimpleTableTable component for table rendering
 */
import React, { useMemo } from 'react'
import SimpleTableTable from '../../../../../Components/SimpleTableTable'
import { tableHeaders, sortableColumns, filterableColumns } from '../settings'
import { getFooterData, formatData } from '../util'
import letterboxMissionsTableRowRenderer from '../blocks/letterboxMissionsTableRowRenderer'
import { authorization } from '../../../../../Module/Auth/Auth'

/**
 *
 * @param {array} props.missions Missions that should be rendered into the table
 * @param {array} props.checkboxesMap Hashmap that indicates which table rows (missions) are checked
 * @param {array} props.onCheckboxChange Function that will be called on checkbox change
 *
 * @returns {JSX.Element} Missions table with filters, search and sortable columns
 *
 * @example
 * <LetterboxMissionsTable
 *   missions={[{ id: 10022, density: 1, ...mission }]}
 *   checkboxesMap={{ 10022: true, 12320: false }}
 *   onCheckboxChange={() => {}}
 * />
 */
const LetterboxMissionsTable = ({
  missions,
  checkboxesMap,
  onCheckboxChange,
  onTableDataUpdate,
  onDelete,
}) => {
  const postRowRender = mission => {
    return letterboxMissionsTableRowRenderer({
      id: mission.id,
      label: mission.label,
      onCheckboxChange,
      cancelled: mission.cancelled,
      status: mission['Status'],
      density: mission['Density'],
      addresses: mission['Addresses'],
      payAdjustment: mission['Pay Adjustment'],
      costPerFlyer: mission['Cost Per Flyer'],
      flyerCode: mission['Flyer Code'],
      totalFlyersDistributed: mission['Flyers Distributed'],
      packSize: mission['Pack Size'],
      week: mission['Week'],
      dateTime: mission['Date'],
      isChecked: Boolean(checkboxesMap[mission.id]),
      baName: mission['BA'],
      baId: mission['userId'],
      cityId: mission['cityId'],
      onDelete,
    })
  }

  const tableHeadersUpdated = useMemo(
    () =>
      authorization.isClientRole()
        ? tableHeaders.filter(
            item =>
              ![
                'Density',
                'Addresses',
                'Pay Adjustment',
                'Cost Per Flyer',
                'Date',
              ].includes(item),
          )
        : tableHeaders,
    [tableHeaders],
  )

  const formattedData = formatData(missions)
  return (
    <SimpleTableTable
      header={tableHeadersUpdated}
      data={formattedData}
      filterOn={filterableColumns}
      sortOn={sortableColumns}
      postRowRender={postRowRender}
      footerRender={getFooterData}
      showPages={false}
      onTableDataUpdate={onTableDataUpdate}
    />
  )
}

export default LetterboxMissionsTable



// WEBPACK FOOTER //
// ./src/Containers/LetterboxMissions/blocks/LetterboxMissionsTable/container/LetterboxMissionsTable.js